/*
 * Home: analytics compare slider (sections/home-analytics.liquid).
 * The data image sits over the video, clipped with clip-path: inset(0 0 0 X%)
 * where X is --split. A transparent full-size range input gives drag and
 * keyboard control.
 *
 * Scroll-pinned wipe: the slider sits in a tall track and its inner wrapper is
 * position: sticky, vertically centred. Scrolling through the track moves the
 * split from 100% (all video) to 0% (all data), holding 12% at each end with
 * an ease in between. Once the visitor drags, scroll stops driving it. Under
 * reduced motion it stays a static 50% split that can still be dragged.
 */
(function () {
  var HOLD = 0.12;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function ease(q) {
    return q < 0.5 ? 2 * q * q : 1 - Math.pow(-2 * q + 2, 2) / 2;
  }

  function initCompare(track) {
    var sticky = track.querySelector('[data-compare-sticky]');
    var box = track.querySelector('[data-compare]');
    var range = track.querySelector('[data-compare-range]');
    if (!sticky || !box || !range) return;

    var manual = false;
    var raf = null;
    var current = null;

    function setSplit(value) {
      var v = Math.round(value * 10) / 10;
      if (v === current) return;
      current = v;
      box.style.setProperty('--split', v + '%');
      range.value = String(Math.round(v));
      range.setAttribute('aria-valuetext', Math.round(100 - v) + '% data');
    }

    function takeOver() {
      manual = true;
      setSplit(Number(range.value));
    }

    range.addEventListener('input', takeOver);
    range.addEventListener('change', takeOver);

    if (reduce && reduce.matches) {
      setSplit(50);
      return;
    }

    function layout() {
      var vh = window.innerHeight || 1;
      var small = window.innerWidth < 768;
      track.style.setProperty('--track-height', (small ? 1600 : 2200) + 'px');
      var h = sticky.offsetHeight;
      track.style.setProperty('--sticky-top', Math.max(24, vh / 2 - h / 2) + 'px');
    }

    function update() {
      raf = null;
      if (manual) return;
      var vh = window.innerHeight || 1;
      var h = sticky.offsetHeight;
      var r = track.getBoundingClientRect();
      var top = Math.max(24, vh / 2 - h / 2);
      // 0 when the slider pins, 1 when it releases.
      var p = Math.min(1, Math.max(0, (top - r.top) / Math.max(1, r.height - h)));
      var q = Math.min(1, Math.max(0, (p - HOLD) / (1 - 2 * HOLD)));
      setSplit((1 - ease(q)) * 100);
    }

    function schedule() {
      if (manual || raf) return;
      raf = window.requestAnimationFrame(update);
    }

    track.classList.add('is-pinned');
    layout();
    update();

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () {
      layout();
      schedule();
    });
  }

  function init() {
    document.querySelectorAll('[data-compare-track]').forEach(initCompare);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
